import React from 'react';
import { VideoItem, Category } from '@/lib/supabase';
import VideoCard from './VideoCard';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { Switch } from './ui/switch';
import { Label } from './ui/label';
import { Collection as CollectionType } from '@/lib/supabase';
import CategorySelect from './CategorySelect';
import TagInput from './TagInput';

interface Props {
  collection: CollectionType & { videos?: VideoItem[]; categories?: Category[] };
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onPublicChange: (isPublic: boolean) => void;
  onTagsChange: (tags: string[]) => void;
  onCategoryChange: (categories: Category[]) => void;
  onRemoveVideo: (videoId: string) => void;
  onSave: () => void;
}

const Collection: React.FC<Props> = ({
  collection,
  onNameChange,
  onDescriptionChange,
  onPublicChange,
  onTagsChange,
  onCategoryChange,
  onRemoveVideo,
  onSave,
}) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="name">Name</Label>
        <Input
          id="name"
          value={collection.name}
          onChange={(e) => onNameChange(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={collection.description || ''}
          onChange={(e) => onDescriptionChange(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="tags">Tags</Label>
        <TagInput value={collection.tags || []} onChange={onTagsChange} />
      </div>

      <div className="space-y-2">
        <Label htmlFor="categories">Categories</Label>
        <CategorySelect
          value={collection.categories || []}
          onChange={onCategoryChange}
        />
      </div>

      <div className="flex items-center space-x-2">
        <Switch
          id="public"
          checked={collection.is_public}
          onCheckedChange={onPublicChange}
        />
        <Label htmlFor="public">Public</Label>
      </div>

      <div>
        <Button onClick={onSave}>Save</Button>
      </div>

      {collection.videos && collection.videos.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {collection.videos.map((video) => (
            <VideoCard
              key={video.id}
              video={video}
              onRemove={() => onRemoveVideo(video.id)}
              editable
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Collection;